import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { components } from '@episource/epi-storybook';
import epiPortalWhiteLogo from '../../assets/images/epiportal-logo-white.svg';
import UserMenu from './UserMenu';
import AppMenu from './AppMenu';

const { AppBar } = components;
const Header = React.forwardRef((props, ref) => {
  const { activeNavItem, appMeta, profile } = props;
  const [avatarAnchorEl, setAvatarAnchorEl] = useState(null);
  const [appAnchorEl, setAppAnchorEl] = useState(null);
  const navItems = appMeta.isAdmin
    ? [
        {
          link: <Link to="/">Home</Link>,
          active: activeNavItem === 'Home',
        },
        {
          link: <Link to="/administration">Administration</Link>,
          active: activeNavItem === 'Administration',
        },
        {
          link: <Link to="/help">Help</Link>,
          active: activeNavItem === 'Help',
        },
      ]
    : [
        {
          link: <Link to="/">Home</Link>,
          active: activeNavItem === 'Home',
        },
        {
          link: <Link to="/help">Help</Link>,
          active: activeNavItem === 'Help',
        },
      ];

  return (
    <>
      {activeNavItem === 'Home' ? (
        <AppBar
          ref={ref}
          logoUrlPath="/"
          imageLogo={<img src={epiPortalWhiteLogo} alt="Epi Portal" />}
          avatarPicture={profile.picture}
          navItems={navItems}
          hideActionMenu
          onAvatarClick={event => {
            setAvatarAnchorEl(event.currentTarget);
          }}
          onMenuButtonClick={event => {
            setAppAnchorEl(event.currentTarget);
          }}
        />
      ) : (
        <AppBar
          ref={ref}
          primaryNavName={activeNavItem}
          logoUrlPath="/"
          imageLogo={<img src={epiPortalWhiteLogo} alt="Epi Portal" />}
          avatarPicture={profile.picture}
          navItems={navItems}
          hideActionMenu
          onAvatarClick={event => {
            setAvatarAnchorEl(event.currentTarget);
          }}
          onMenuButtonClick={event => {
            setAppAnchorEl(event.currentTarget);
          }}
        />
      )}
      <UserMenu
        anchorEl={avatarAnchorEl}
        isOpen={Boolean(avatarAnchorEl)}
        onClose={() => {
          setAvatarAnchorEl(null);
        }}
      />
      <AppMenu
        anchorEl={appAnchorEl}
        isOpen={Boolean(appAnchorEl)}
        onClose={() => {
          setAppAnchorEl(null);
        }}
      />
    </>
  );
});

Header.defaultProps = {
  activeNavItem: 'Home',
  appMeta: {},
  profile: {},
};

Header.propTypes = {
  activeNavItem: PropTypes.string,
  appMeta: PropTypes.shape({
    isInternal: PropTypes.bool,
    isAdmin: PropTypes.bool,
  }),
  profile: PropTypes.shape({
    picture: PropTypes.string,
  }),
};

const mapStateToProps = state => {
  const { auth } = state;
  return {
    appMeta: auth.profile[process.env.REACT_APP_APP_METADATA_KEY].episourceAccess,
    profile: auth.profile,
  };
};

export default connect(mapStateToProps, () => ({}))(Header);
